import { EmptyState } from "@/components/states/empty";
import { ErrorState } from "@/components/states/error";
import { ForbiddenState } from "@/components/states/forbidden";

export function StatePage({
  resourceType,
  error,
  reset,
  isNotFound,
  emptyResourceType,
  hideIcon,
  hasActiveFilters,
  onCreate,
  onClearFilters,
  hideReturnHome,
  className,
  size = "md",
}: {
  resourceType: Parameters<typeof ErrorState>[0]["resourceType"];
  emptyResourceType: Parameters<typeof EmptyState>[0]["resourceType"];
  hideIcon?: boolean;
  hasActiveFilters?: boolean;
  onCreate?: () => void;
  onClearFilters?: () => void;
  hideReturnHome?: boolean;
  className?: string;
  size?: "sm" | "md";
} & (
  | {
      error: Error;
      reset: () => void;

      isNotFound?: never;
    }
  | {
      error?: never;
      reset?: never;

      isNotFound: boolean;
    }
)) {
  if (isNotFound) {
    return (
      <EmptyState
        className={className}
        hideIcon={hideIcon}
        resourceType={emptyResourceType}
        hasActiveFilters={hasActiveFilters}
        onCreate={onCreate}
        onClearFilters={onClearFilters}
        hideReturnHome={hideReturnHome}
        size={size}
      />
    );
  }
  if (error && "code" in error && error.code === "NOT_FOUND") {
    return (
      <EmptyState
        hideIcon={hideIcon}
        className={className}
        resourceType={emptyResourceType}
        hideReturnHome={hideReturnHome}
        size={size}
      />
    );
  }
  if (error && "code" in error && (error.code === "FORBIDDEN" || error.code === "UNAUTHORIZED")) {
    return (
      <ForbiddenState
        className={className}
        hideIcon={hideIcon}
        resourceType={resourceType}
        hideReturnHome={hideReturnHome}
        size={size}
      />
    );
  }

  return <ErrorState className={className} hideIcon={hideIcon} resourceType={resourceType} reset={reset} size={size} />;
}
